import * as React from 'react'
import { ButtonBase, Grid } from '@mui/material';
import IPatternCategoryStore from '../../_stores/PatternCategoryStore';

export type Props = {
	category: IPatternCategoryStore
	className?: string
	onClick?: Function
}

export default class PatternBrowserCategory extends React.Component<Props> {
	render() {
		let style = {
			backgroundImage: "url('"+this.props.category.thumbnail+"')"
		};

		return <div style={style} className={"module-creator-module image-card mdc-card mdc-card--outlined " + this.props.className} onClick={() => this.props.onClick(this.props.category.id)}>
				<ButtonBase>
					<h4><span>{this.props.category.title}</span></h4>
				</ButtonBase>
			</div>
	}
}